<template>
  <Popover ref="itemPopover" :showHeader="true" :headerTitle="`${itemTitle}`">
    <div class="production-preview-panel-popover" v-if="orderItem">
      <div class="row">
        <div class="col-6 panel-popover-display">
          <div class="font-weight-bold">Quantity</div>
          <div>{{orderItem.quantity}}</div>
          <div class="font-weight-bold">Stock</div>
          <div>{{orderItem.stock.code}} - {{orderItem.stock.name}}</div>
          <div class="font-weight-bold">Description</div>
          <div>{{orderItem.description}}</div>
          
          <template v-if="orderItem.generatedDescription">
            <div class="font-weight-bold">Additional Info</div>
            <div>{{orderItem.generatedDescription}}</div>
          </template>
          <template v-if="orderItem.mark">
            <div class="font-weight-bold">Mark</div>
            <div>{{orderItem.mark}}</div>
          </template>
          <template v-if="orderItem.notes">
            <div class="font-weight-bold">Notes</div>
            <div>{{orderItem.notes}}</div>
          </template>

          <div class="font-weight-bold" v-if="orderItem.stockType == InventoryStockTypes.glass">Processed</div>
          <div>{{orderItem.isProcessedItem ? 'Yes' : 'No'}}</div>

          <div class="font-weight-bold" v-if="orderItem.stockType == InventoryStockTypes.glass || orderItem.stockType == InventoryStockTypes.template">Size</div>
          <div>{{orderItem.glassHeight}}x{{orderItem.glassWidth}}</div>

          <div class="font-weight-bold">Despatched Quantity</div>
          <div>{{orderItem.despatchedQuantity}} / {{orderItem.quantity}}</div>
        </div>
        <div class="col-6 panel-popover-display">
          <template v-if="orderItem.isCancelled">
            <strong>Cancelled Reason</strong>
            <div v-html="convertNewlinesToBreaks(orderItem.cancelledReason)"></div>
          </template>
        </div>
      </div>
      <div class="row">
        <div class="col-12 panel-popover-display">
          <FormHorizontalRule />
          <div class="font-weight-bold">Associated Despatch Tasks</div>
          <template v-if="linkedTaskInfoList.length > 0">
            <div v-for="task of linkedTaskInfoList" :key="task.id" class="row">
              <div class="col-3">
                <LinkTask :id="task.id" :name="task.sequenceNumber" />
              </div>
              <div class="col-3">
                <LabelBadge :labelClass="`label-task-status-${task.status}`">{{task.status | formatLookupName(TaskStatusTypeLookup)}}</LabelBadge>
              </div>
              <div class="col-6">
                <template v-if="task.status == TaskStatusTypes.ready || task.status == TaskStatusTypes.loading">
                  {{task.startedDate | formatDateTime}}
                </template>
                <template v-if="task.status == TaskStatusTypes.completed">
                  {{task.completedDate | formatDateTime}}
                </template>
                <template v-if="task.status == TaskStatusTypes.cancelled">
                  {{task.cancelledDate | formatDateTime}}
                </template>
              </div>
            </div>
          </template>
          <div v-if="linkedTaskInfoList.length == 0">None</div>
        </div>
      </div>
    </div>
  </Popover>
</template>

<style scoped>
.production-preview-panel-popover {
  padding: 10px;
  font-size: 0.8rem;
  line-height: 1.1rem;
  min-width: 400px;
}
.panel-popover-display > div {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
</style>

<script>
import _ from 'lodash'
import Popover from '@/components/popover.vue'

import { DespatchTypeLookup, TaskStatusTypes, TaskStatusTypeLookup, InventoryStockTypes } from '@/store/types'

export default {
  name: 'OrderProductionOrderItemPopover',
  components: {
    Popover
  },
  computed: {
    itemTitle() {
      if(!this.orderItem)
        return ''
      return `${this.orderItem.quantity}x ${this.orderItem.stock.name}`
    }
  },
  data() {
    return {      
      orderItem: null,
      taskList: [],
      linkedTaskInfoList: []
    }
  },
  created() {
    this.InventoryStockTypes = InventoryStockTypes
    this.DespatchTypeLookup = DespatchTypeLookup
    this.TaskStatusTypes = TaskStatusTypes
    this.TaskStatusTypeLookup = TaskStatusTypeLookup
  },
  methods: {
    displayFromElement(element, order, orderItem, taskList) {
      this.orderItem = orderItem
      this.taskList = taskList

      this.calculateLinkedTaskList()

      this.$refs.itemPopover.displayFromElement(element)
    },
    calculateLinkedTaskList() {
      this.linkedTaskInfoList = []
      if(!this.orderItem)
        return

      this.taskList.forEach(task => {
        if(task.taskItems) {
          let linkedTaskItems = task.taskItems.filter(taskItem => {
            if(taskItem.orderItems)
              return taskItem.orderItems.find(listOrderItem => listOrderItem.id == this.orderItem.id) != null
            return false
          })

          if(linkedTaskItems.length > 0) {
            this.linkedTaskInfoList.push(_.merge(task, {
              linkedTaskItems: linkedTaskItems
            }))
          }
        }
      })
    }
  }
}
</script>